import { MEETING_RESPONSES, VIEW_MODES } from '../constants/meetingConstants';
import i18n from 'i18next';
import { useUserIdentityStore } from '@stores/userIdentityStore';
var getUrlParameter = function getUrlParameter(name, searchString) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(searchString);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};
var getViewModeName = function getViewModeName(viewMode) {
    switch(viewMode){
        case VIEW_MODES.AGENDA:
            return i18n.t('meetingHelper_agendaView', 'Agenda view');
        case VIEW_MODES.WORK_WEEK:
            return i18n.t('meetingHelper_workWeekView', 'Work week view');
        case VIEW_MODES.WEEK:
            return i18n.t('meetingHelper_weekView', 'Week view');
        default:
            return i18n.t('meetingHelper_noView', 'No view mode');
    }
};
var getMeetingResponse = function getMeetingResponse(item) {
    var _ref;
    var _item_organizer_emailAddress, _item_organizer, _item_attendees, _response__status, _response_;
    var myself = useUserIdentityStore.getState().mail;
    var isOrganizer = myself === ((_item_organizer = item.organizer) === null || _item_organizer === void 0 ? void 0 : (_item_organizer_emailAddress = _item_organizer.emailAddress) === null || _item_organizer_emailAddress === void 0 ? void 0 : _item_organizer_emailAddress.address);
    if (isOrganizer) {
        return MEETING_RESPONSES.ACCEPTED;
    }
    var response = (_ref = item === null || item === void 0 ? void 0 : (_item_attendees = item.attendees) === null || _item_attendees === void 0 ? void 0 : _item_attendees.filter(function(e) {
        var _e_emailAddress;
        return ((_e_emailAddress = e.emailAddress) === null || _e_emailAddress === void 0 ? void 0 : _e_emailAddress.address) === myself;
    })) !== null && _ref !== void 0 ? _ref : [];
    if (response.length === 0) {
        return MEETING_RESPONSES.NOT_RESPONDED;
    }
    switch((_response_ = response[0]) === null || _response_ === void 0 ? void 0 : (_response__status = _response_.status) === null || _response__status === void 0 ? void 0 : _response__status.response){
        case 'accepted':
            return MEETING_RESPONSES.ACCEPTED;
        case 'tentativelyAccepted':
            return MEETING_RESPONSES.TENTATIVE;
        case 'declined':
            return MEETING_RESPONSES.DECLINED;
        default:
            return MEETING_RESPONSES.NOT_RESPONDED;
    }
};
var getLocationInfo = function getLocationInfo(meeting) {
    var _meeting_location, _meeting_onlineMeeting;
    var locationInfo = null;
    if ((_meeting_location = meeting.location) === null || _meeting_location === void 0 ? void 0 : _meeting_location.displayName) {
        locationInfo = meeting.location.displayName;
    } else if (meeting.isOnlineMeeting && ((_meeting_onlineMeeting = meeting.onlineMeeting) === null || _meeting_onlineMeeting === void 0 ? void 0 : _meeting_onlineMeeting.joinUrl)) {
        locationInfo = 'Microsoft Teams Meeting';
    }
    return locationInfo || 'No location information';
};
// Whether a meeting in a list is one of the meetings a removal took out of the user's meetings list.
var isRemovedMeeting = function isRemovedMeeting(meeting, removedMeeting, scope) {
    if (scope === 'series') {
        return !!removedMeeting.seriesMasterId && meeting.seriesMasterId === removedMeeting.seriesMasterId;
    }
    return meeting.meetingId === removedMeeting.meetingId;
};
export { getUrlParameter, getViewModeName, getMeetingResponse, getLocationInfo, isRemovedMeeting };
